import { createFileRoute } from "@tanstack/react-router";
import Customers from "@/pages/Customers";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/th/customers")({
  head: () => pageHead("/customers", "th"),
  component: Customers,
});
